export enum IconType {
    CustomImage = 'customImage',
    Icon = 'icon'
}